import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import { useFormContext } from 'modules/client/legal/forms/companyActivitiesForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props
  extends Omit<FormContentProps, 'onRemoveActivity' | 'onAddActivity'> {}

export const CompanyActivitiesSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  const { values, setFieldValue } = useFormContext();

  const onAddActivity = () => {
    const activityTypes = [...values.activityTypes, { name: '' }];
    setFieldValue('activityTypes', activityTypes, false);
  };

  const onRemoveActivity = (index: number) => {
    const activityTypes = [...values.activityTypes];
    activityTypes.splice(index, 1);
    setFieldValue('activityTypes', activityTypes, false);
  };

  return (
    <Section
      datax="companyActivitiesSection"
      title={t('client.legal.companyActivities.title')}
    >
      <FormContent
        {...formProps}
        onAddActivity={onAddActivity}
        onRemoveActivity={onRemoveActivity}
      />
    </Section>
  );
};
